<div class="flex flex-col border-zinc-200">
  @if (!showListOnly()) {
    <div class="mr-0.5 flex flex-row items-center justify-between">
      <div class="flex flex-row items-center gap-0.5 font-bold">
        <label class="form-label">{{ title() | translate }}</label>
      </div>
      <div>
        @if (canManage) {
          @if (!isAdding()) {
            <button
              appButton
              size="md"
              class="ml-2 hover:!bg-black/5"
              icon="ellipsis-vertical"
              color="transparent"
              iconPosition="only-icon"
              (click)="menu.toggle($event); $event.stopPropagation()"></button>
            <app-menu #menu>
              <app-menu-item
                [icon]="'person'"
                [label]="'i18n.WpAssigneesComponent.addAssignee' | translate"
                (action)="addAssignee()" />
              <app-menu-item
                icon="people"
                [label]="'i18n.WpAssigneesComponent.addGroupMembers' | translate"
                (action)="addGroupMembers.emit()" />
              <app-menu-item
                icon="delete-outline"
                [label]="'i18n.WpAssigneesComponent.clear' | translate"
                (action)="clearAssignees()" />
            </app-menu>
          } @else {
            <button
              appButton
              icon="close"
              color="default"
              size="md"
              iconPosition="only-icon"
              (click)="abortAdd()"></button>
          }
        }
      </div>
    </div>
  }
  <div
    class="flex flex-col rounded-lg border border-zinc-200"
    [ngClass]="{
      '!border-red-500': canManage && !control().valid && control().touched
    }">
    @for (assigneeControl of control().controls; track assigneeControl; let index = $index; let last = $last) {
      <div
        class="flex h-9 flex-row items-center justify-between py-1 text-sm"
        [ngClass]="{ 'border-b border-zinc-200': !last }">
        @if (!assigneeControl.value) {
          <app-assignee-picker
            class="w-full"
            [projectId]="projectId()"
            [excludeIds]="currentIds()"
            [control]="assigneeControl"></app-assignee-picker>
        } @else {
          <div class="flex w-full flex-row gap-2 px-1.5">
            <div class="flex flex-row items-center">
              <p-avatar
                styleClass="!size-5 !rounded-full border bg-zinc-100 text-sm my-0.5 mr-3"
                [label]="(assigneeControl.value | userAvatar).at(0)"
                [style]="{
                  'background-color': assigneeControl.value.color.bg,
                  color: assigneeControl.value.color.text
                }"></p-avatar>
              <div>{{ assigneeControl.value | userFullName }}</div>
            </div>
          </div>

          @if (canManage) {
            <button
              appButton
              size="md"
              color="default"
              icon="delete-outline"
              iconPosition="only-icon"
              (click)="remove(index)"></button>
          }
        }
      </div>
    }

    @if (!hasItems()) {
      <span class="empty-content-placeholder">
        {{ noItemsLabel() | translate }}
      </span>
    }
  </div>
</div>
